export enum ThemeBorderShadowType {
    None = 'none',
    Border = 'border',
    Shadow = 'shadow'
}
